export const SearchOrder = {
  bindings: {
    list: '<',
    title: '@',
    onClick: '&',
  },

  template: `
    <div class="search-order btn-group d-flex justify-content-between align-items-center">
      <small>{{ $ctrl.title }}</small>
      <button class="btn btn-link dropdown-toggle d-flex align-items-center pr-1"
        type="button"
        data-toggle="dropdown">
        <small ng-repeat="item in $ctrl.list | filter: { checked: true }">
          {{ item.name }}
        </small>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <button class="btn-link dropdown-item btn btn-link rounded-0"
          type="button"
          ng-repeat="item in $ctrl.list | filter: { checked: false }"
          ng-click="$ctrl.onClick({ value: item.value })">
          {{ item.name }}
        </button>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchOrder.js